export default __webpack_public_path__ + "static/media/ro.28ad78d7.svg";